import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SptAudioService} from '@spout/web-global/data-access';

@Component({
  selector: 'spt-help-gain-content',
  templateUrl: './help-gain-content.component.html',
  styleUrls: ['./help-gain-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpGainContentComponent {
  constructor(private sptAudioService: SptAudioService) {}
  refresh(): void {
    this.sptAudioService.refreshAudioDeviceList().subscribe(() => {});
  }
}
